import { useNavigate } from "@/lib/router-compat";

interface AffiliateRedirectParams {
  cardId: string;
  cardName: string;
  issuerName: string;
  affiliateUrl: string;
  source: 'grid_view' | 'table_view' | 'detail_page' | 'assistant' | 'article_sidebar';
  offerTitle?: string;
  annualFee?: number;
  effectiveRate?: number;
}

/**
 * React Router-based affiliate redirect hook
 * Navigates to redirect page using React Router to keep app mounted and GTM initialized
 */
export function useAffiliateRedirect() {
  const navigate = useNavigate();

  const handleAffiliateRedirect = (params: AffiliateRedirectParams) => {
    try {
      // Navigate using React Router to keep app mounted
      navigate('/zum-anbieter', {
        state: {
          cardId: params.cardId,
          cardName: params.cardName,
          bankName: params.issuerName,
          affiliateUrl: params.affiliateUrl,
          source: params.source,
          offerTitle: params.offerTitle,
          annualFee: params.annualFee,
          effectiveRate: params.effectiveRate,
        },
      });
    } catch (error) {
      console.error('Error navigating to redirect page:', error);
      // Fallback: direct redirect
      window.location.href = params.affiliateUrl;
    }
  };

  return { handleAffiliateRedirect };
}
